import React from 'react'
import styles from './Input.module.css'
import InputMask from 'react-input-mask'

const Input = ({ label, type, name, value, onChange, error }) => {
  return (
    <div className={styles.wrapperInput}>
      <label htmlFor={name} className={styles.label}>
        {label}
      </label>
      <InputMask
        mask="999.999.999-99"
        id={name}
        name={name}
        className={styles.input}
        type={type}
        value={value}
        onChange={onChange}
      />
      {error && <p className={styles.error}>{error}</p>}
    </div>
  )
}

export default Input
